export function  inStore (data){
    return {
        type : 'store',
        data: data
    }
}
export function inProduct  (){
    return {
        type : 'product'
    }
}
// here actions will handle my cart
export function addProduct(data){
    return{
        type: 'add',
        data: data
    }
}
export function removeProduct(data){
    return{
        type: 'remove',
        data: data
    }
}
export function clear(){
    return{
        type: 'clear',
    }
}
export function setCar(data){
    return{
        type: 'setAdd',
        data: data,
    }
}
export function setMinus(data){
    return {
        type: 'setMinus',
        data: data
    }
}
export function setError(data){
    return  {
        type: 'setError',
        data: data
    }
}
export function unsetError(){
    return  {
        type: 'unsetError',
    }
}

